export const STATISTICS_PARENT_TYPE = "statistics";

export const statisticsMenuItems = [
  { label: "สถิติภาพรวม", type: "statistics_overview" },
  { label: "สถิติหน่วยงานที่เปิดรับฟัง", type: "statistics_agency" },
  { label: "สถิติการรับฟังร่างกฎหมาย", type: "statistics_draft_law" },
  {
    label: "สถิติการรับฟังประเมินผลสัมฤทธิ์",
    type: "statistics_assessment",
  },
];

export const STATISTICS_ALL_TYPES = [
  STATISTICS_PARENT_TYPE,
  ...statisticsMenuItems.map((item) => item.type),
];

export const STATISTICS_ROUTE_MAP = {
  [STATISTICS_PARENT_TYPE]: "/dashboard",
  statistics_overview: "/dashboard",
  statistics_agency: "/dashboard/agency",
  statistics_listening: "/dashboard/listening",
  statistics_draft_law: "/dashboard/draftlaw",
  statistics_assessment: "/dashboard/evaluate",
  statistics_all_law: "/dashboard/summary",
  statistics_month: "/dashboard/month",
};

export const resolveStatisticsRoute = (type = STATISTICS_PARENT_TYPE) =>
  STATISTICS_ROUTE_MAP[type] || STATISTICS_ROUTE_MAP[STATISTICS_PARENT_TYPE];
